export const JOB_SAVED_SUBMIT_REQUEST = 'job/saved-submit-request'
export const JOB_SAVED_SUBMIT_SUCCESS = 'job/saved-submit-success'
export const JOB_SAVED_SUBMIT_FAILED = 'job/saved-submit-failed'
